import { Card } from "@fpsoftware/mvp";
import { useProfile } from "@/auth/useProfile";
import styles from "./IntegrateWebsiteCard.module.css";

function getCode(token: string) {
  return `
<style>
    #submit-iframe {
        display: block;
        width: 100%;
        border: none;
        margin: 32px auto;
        border-radius: 8px;
        overflow: hidden;
        transition: height 0.2s;

        &:focus {
            outline: none;
        }
    }
</style>
<iframe src="https://app.borrowgenius.com/submit/${token}" frameborder="0" scrolling="no" id="submit-iframe"></iframe>
<script>
    const iframe = document.querySelector("#submit-iframe");

    window.addEventListener("message", (event) => {
        // Height change event handler
        if (event.source === iframe.contentWindow) {
            iframe.style.height = event.data + "px";
        }
    });
</script>
    `.trim();
}

export function IntegrateWebsiteCard() {
  const { profile } = useProfile();
  return (
    <Card>
      <Card.Header>Integrate in your website</Card.Header>
      <Card.Body>
        Paste the following HTML code into your website.
        <br />
        <br />
        <textarea readOnly className={styles.textArea} rows={20}>
          {getCode(profile.companyToken)}
        </textarea>
      </Card.Body>
    </Card>
  );
}
